import type { FieldHelpContent } from "@/components/ui/field-help";

/** Sparse Product glance help — plan/46. */
export const productHelp = {
  kind: {
    title: "Kind",
    summary:
      "Stocked items keep warehouse qty and cost. Service items sell without stock (labor, fees, delivery).",
    example: "Bag of rice → Stocked. Installation fee → Service.",
    useCases: [
      "Don’t force a warehouse for services — kind decides whether On hand appears.",
    ],
  },
  avgCost: {
    title: "Avg cost",
    summary:
      "Moving-average unit cost from receipts, issues, and conversions — used for COGS when you sell stocked goods.",
    example: "Buy 10 @ ₱50 then 10 @ ₱70 → avg cost ₱60 until the next move.",
    detail:
      "May be hidden by permission (redacted). Not the same as a price-list sell price.",
    useCases: [
      "Check margin: sell price on a list vs this avg cost.",
    ],
  },
  priceLists: {
    title: "Price lists",
    summary:
      "How many price lists include this product. Sell price comes from the list on the SO/POS — not from avg cost.",
    example: "Retail + Wholesale listed → “2 lists” on the glance.",
    useCases: [
      "Open the product to set or change list prices.",
    ],
  },
  lowStockThreshold: {
    title: "Low-stock threshold",
    summary:
      "Optional override for this product. Empty uses the org default from Settings. Home Low stock and Inventory “Low stock” use the effective value.",
    example: "Org default 0, set 10 here → this SKU warns at ≤ 10.",
    useCases: [
      "Leave blank for most items; raise only for high-velocity SKUs.",
    ],
  },
} as const satisfies Record<string, FieldHelpContent>;
